import { WindowWithEnv } from '@realwear-cloud/shared/env';

const windowEnv = (window as WindowWithEnv).env;

export const environment = {
  production: true,
  stsServer: windowEnv.stsServer || '',
  apiBase: windowEnv.apiBase || ''
};
